<template>
  <router-view></router-view>
</template>

<script>
import nav from "@/containers/_nav";
import router from "@/router";

export default {
  name: 'App',
  async mounted() {
    if (this.$store.state.User.id === 0) {
      try {
        const res = await window.REST.auth(null, null);

        if (res.data.isAuthorized !== true) {
          this.message = res.data.message;
          if (this.$route.name !== 'Login') {
            router.push({ name: 'Login' });
          }
          return;
        }

        res.data.User.isAuthorized = true;
        this.$store.commit('set', ['User', res.data.User]);

        this.createRoutes();

        const statusesRes = await window.REST.get(
            "client_order_statuses",
            null, null, null, null, 1, 1000
        );
        this.$store.commit('set', ['statuses', statusesRes.data]);
      } catch (error) {
        console.error('Authorization error:', error);
        if (this.$route.name !== 'Login') {
          router.push({ name: 'Login' });
        }
      }
    }
  },
  methods: {
    createRoutes() {
      // Гарантируем, что sidebar_elems существует и это массив с нужной структурой
      this.$store.commit('set', ['sidebar_elems', JSON.parse(JSON.stringify(nav))]);
      const sidebarElems = this.$store.state.sidebar_elems;

      // Проверяем что sidebarElems - массив и первый элемент имеет _children
      if (!Array.isArray(sidebarElems) || !sidebarElems[0] || !Array.isArray(sidebarElems[0]._children)) {
        console.error('sidebar_elems structure is invalid');
        return;
      }

      const children = sidebarElems[0]._children;
      const role = this.$store.state.User.role;

      // Общая функция для добавления заявки по роли
      const addOrdersNavItem = (toPath) => {
        children.push({
          _name: 'CSidebarNavItem',
          name: 'Заявки',
          to: toPath,
          icon: 'cil-flight-takeoff',
        });
      };

      if (role === 'Admin') {
        addOrdersNavItem('/orders/');

        children.push({
          _name: 'CSidebarNavTitle',
          _children: ['Компания'],
          name: 'Компания',
        });

        children.push({
          _name: 'CSidebarNavItem',
          name: 'Пользователи',
          to: '/users',
          icon: 'cil-user',
        });

        children.push({
          _name: 'CSidebarNavItem',
          name: 'Партнёры',
          to: '/partners',
          icon: 'cil-sitemap',
        });

        children.push({
          _name: 'CSidebarNavItem',
          name: 'Франшизы',
          to: '/franchises',
          icon: 'cil-sitemap',
        });
      }

      if (role === 'MainUser') {
        addOrdersNavItem('/orders');
      }

      if (role === 'Manager') {
        addOrdersNavItem('/orders/manager');
      }

      if (role === 'BuyManager') {
        addOrdersNavItem('/orders/buymanager');
      }

      if (role === 'Fullfill') {
        addOrdersNavItem('/orders/fullfill');
      }

      if (role === 'RegDir') {
        addOrdersNavItem('/orders/regdir');
      }

      if (role === 'MainUser' || role === 'Guest') {
        children.push({
          _name: 'CSidebarNavTitle',
          _children: ['Отчеты'],
          name: 'Отчеты',
        });

        children.push({
          _name: 'CSidebarNavItem',
          name: 'Поставки',
          to: '/partners/incomes',
          icon: 'cil-flight-takeoff',
        });

        children.push({
          _name: 'CSidebarNavItem',
          name: 'Склад',
          to: '/partners/stocks',
          icon: 'cil-window-restore',
        });

        children.push({
          _name: 'CSidebarNavItem',
          name: 'Заказы',
          to: '/partners/orders',
          icon: 'cil-basket',
        });

        children.push({
          _name: 'CSidebarNavItem',
          name: 'Продажи',
          to: '/partners/sales',
          icon: 'cil-chart-line',
        });

        children.push({
          _name: 'CSidebarNavItem',
          name: 'Отчёт по продажам',
          to: '/partners/stats',
          icon: 'cil-chart',
        });

        children.push({
          _name: 'CSidebarNavItem',
          name: 'Отчёт по КиЗам',
          to: '/partners/excises',
          icon: 'cil-library',
        });
      }
    }
  },
  computed: {
    role() {
      return this.$store.state.User.role;
    },
  }
}
</script>

<style lang="scss">
// Import Main styles for this application
@import 'assets/scss/style';
</style>
